import clsx from "clsx";
import { PureComponent, PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  className?: string;
}
export default class EditorBox extends PureComponent<Props> {
  render() {
    const { children, className } = this.props;

    return <div className={clsx(["ct-editor-box", className])}>{children}</div>;
  }
}
